import * as React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { getProductById } from "../../Utils/vendor-customer-service";
import {
  extractIdFromGid,
  extractNumberFromString,
  possibleNames,
} from "../../Utils/constant";
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

function ProductSelection(props) {
  const { productId, addProductToCart, productIndex } = props;
  const [loading, setLoading] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [showErr, setShowErr] = React.useState(false);
  const [price, setPrice] = React.useState();
  const [product, setProduct] = React.useState({});
  // selectedOption will be like [{index: 0, value: 1.5D}]
  const [selectedOption, setSelectedOption] = React.useState([]);
  const [activeIndices, setActiveIndices] = React.useState([]);
  const [quantity, setQuantity] = React.useState(1);
  const [totalPc, setTotalPc] = React.useState();
  const [unit, setUnit] = React.useState();

  let packSizePosition;

  React.useEffect(() => {
    if (productId) {
      const pId = extractIdFromGid(productId);
      fetchProduct(pId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);

  const fetchProduct = (id) => {
    setLoading(true);
    try {
      let res = getProductById(id);
      res.then((data) => {
        if (data.status === 200) {
          const ps = data?.data?.product || [];
          setProduct(ps);
          setLoading(false);
          setQuantity(1);
          setDisabled(false);
          console.log(data.data.product);
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const splitTitleToArray = (title) =>
    title.split(" / ").map((str) => str.trim());

  React.useEffect(() => {
    if (product?.options) {
      setActiveIndices(
        product?.options?.length
          ? Array(product?.options?.length).fill(null)
          : null
      );
      if (product?.totalInventory === 0) {
        setDisabled(true);
      }
      if (product?.variants?.nodes.length === 1) {
        setPrice(product?.priceRange?.minVariantPrice?.amount);
        setTotalPc(1);
        setUnit("PC");
      }
      product?.options?.forEach((option, indx) => {
        if (possibleNames.includes(option?.name.toLowerCase())) {
          packSizePosition = indx;
        }
      });
    }
    let found = false;
    // Check if all variant has all zero  quantityAvailable
    let weHaveNothingToSelect;
    let variantLengths = 0;
    //  // Check if all variant has all zero  quantityAvailable ends
    if (product?.variants && product?.variants?.nodes) {
      product?.variants?.nodes?.forEach((variant, indx) => {
        const title = variant?.title;
        const arr = splitTitleToArray(title);
        if (variant?.quantityAvailable > 0) {
          if (!found) {
            // onload option selected
            setSelectedOption(arr);
            const extractData = extractNumberFromString(arr[packSizePosition]);
            setTotalPc(extractData?.number || 1);
            setUnit(extractData?.unit || "PC");
            setPrice(variant?.price?.amount);
          }
          variant.compareQty = arr;
          found = true;
        } else {
          variant.compareQty = arr;
          if (indx === 0) {
            weHaveNothingToSelect = arr;
          }
          variantLengths += 1;
        }
      });
      if (variantLengths === product?.variants?.nodes?.length) {
        setSelectedOption(weHaveNothingToSelect);
        const extractData = extractNumberFromString(weHaveNothingToSelect[0]);
        setTotalPc(extractData?.number || 1);
        setUnit(extractData?.unit || "PC");
        setPrice(product?.variants?.nodes[0]?.price?.amount);
      }
    }
  }, [product?.options]);

  // compare array
  function commonElements(arr1, arr2) {
    if (arr1?.length > 0 && arr1?.length > 0) {
      return arr1.every((element) => arr2.includes(element));
    }
    return false;
  }

  const selectOption = (arrayIndex, itemIndex, optionVal) => {
    // Below code help in selecting options and setting their class to active
    const newActiveIndices = [...activeIndices];
    newActiveIndices[arrayIndex] = itemIndex;
    setActiveIndices(newActiveIndices);
    // Below code ends

    // Set selected option
    const optionsArr = [...selectedOption];
    optionsArr[arrayIndex] = optionVal;
    setSelectedOption(optionsArr);
    const extractData = extractNumberFromString(optionsArr[packSizePosition]);
    setTotalPc(extractData?.number || 0);
    setUnit(extractData?.unit || "PC");

    let returnVal;
    let found = false;
    if (product?.variants && product?.variants?.nodes) {
      product?.variants.nodes.forEach((variant) => {
        if (found) return; // Skip iteration if already found
        if (commonElements(variant.compareQty, optionsArr)) {
          setPrice(variant?.price?.amount);
          returnVal = variant?.quantityAvailable;
        }
      });
    }
    setShowErr(returnVal < 1);
    setDisabled(returnVal < 1);
  };

  const comparePackSize = (arrayIndex, name, val) => {
    let returnVal = true;

    if (possibleNames.includes(name.toLowerCase())) {
      packSizePosition = arrayIndex;
      let options = [...selectedOption];
      options = options.filter((_, i) => i !== arrayIndex);
      options[arrayIndex] = val;
      if (product?.variants && product?.variants?.nodes) {
        product?.variants.nodes.forEach((variant) => {
          if (commonElements(variant.compareQty, options)) {
            returnVal = variant?.quantityAvailable > 0;
          }
        });
      }
      return returnVal;
    } else {
      return returnVal;
    }
  };

  const handleIncrement = () => {
    setQuantity((prevQuantity) => parseInt(prevQuantity) + 1);
  };

  const handleDecrement = () => {
    setQuantity((prevQuantity) =>
      parseInt(prevQuantity) > 1 ? parseInt(prevQuantity) - 1 : 1
    );
  };

  const handleAddToCart = () => {
    const selectedProduct = {
      id: extractIdFromGid(productId),
      title: product.title,
      price,
      totalPrice: price * quantity,
      quantity,
      totalPc,
      unit,
      selectedOption,
      options: product?.options,
      vendor: product?.vendor,
      productType: product?.productType,
      tags: product?.tags || [],
      images: product?.images?.nodes || [],
      unitPrice: (price / totalPc).toFixed(2),
    };
    addProductToCart(selectedProduct);
  };

  if (!loading && !product.title) {
    return null;
  }
  return (
    <Grid container spacing={3}>
      {loading && <CircularProgress />}
      <Grid item xs={12} md={8} lg={9}>
        <h4>{product?.title}</h4>
        <Typography variant="subtitle1" display="block" gutterBottom>
          <strong style={{ color: "green" }}> ₹{price}</strong>
        </Typography>
        {product?.totalInventory === 0 && (
          <h4 style={{ color: "red" }}>
            <span>OUT OF STOCK</span>
          </h4>
        )}
        <div className="product-detail-box px-15">
          {product?.options &&
            product?.options.length > 0 &&
            product?.options.map((option, arrayIndex) => {
              if (option?.name === "Title") {
                return null;
              }
              return (
                <div key={arrayIndex} className="filter-box">
                  <h4
                    id={
                      arrayIndex > 0 ? "product-option-spacingfrom-2" : "none"
                    }
                    className="filter-title"
                  >
                    {option?.name}:
                  </h4>
                  <div disabled className="filter-content">
                    <ul className="row filter-row g-3">
                      {option?.values &&
                        option?.values.map((val, itemIndex) => {
                          return (
                            <Chip
                              sx={{ mr: 2 }}
                              key={itemIndex}
                              label={val}
                              variant={
                                selectedOption[arrayIndex] === val
                                  ? undefined
                                  : "outlined"
                              }
                              color={
                                selectedOption[arrayIndex] === val
                                  ? "primary"
                                  : undefined
                              }
                              onClick={() =>
                                selectOption(arrayIndex, itemIndex, val)
                              }
                              disabled={
                                comparePackSize(arrayIndex, option?.name, val)
                                  ? false
                                  : true
                              }
                            />
                          );
                        })}
                    </ul>
                  </div>
                </div>
              );
            })}
          <div className="size-detail">
            <h4 id="product-option-spacingfrom-2" className="size-title">
              QUANTITY:
            </h4>
            <div id="estimate-qty-product" className="qty-counter">
              <div id="estimate-height-input" className="input-group">
                <Button
                  size="large"
                  onClick={handleDecrement}
                  variant="contained"
                >
                  <RemoveIcon />
                </Button>
                <TextField
                  name="name"
                  id="name"
                  value={quantity}
                  onChange={(e) => setQuantity(parseInt(e.target.value))}
                  size="small"
                  sx={{ mr: 1, ml: 1 }}
                />
                <Button
                  size="large"
                  onClick={handleIncrement}
                  variant="contained"
                >
                  <AddIcon />
                </Button>
              </div>
              {/* <li id="estimate-selected-product" className="col-6">
                <h6 id="color-orange" className="content-color">
                  Total Quantity :{" "}
                  <strong>
                    {totalPc * quantity || ""} {unit}
                  </strong>
                </h6>
                <span className="content-color">
                  {price &&
                    totalPc &&
                    unit &&
                    `@ ₹${(price / totalPc).toFixed(2)} per ${unit}`}
                </span>
                {
                  <h6 className="text-green">
                    Total Amount: <strong> ₹{price * quantity}</strong>
                  </h6>
                }
              </li> */}
            </div>
          </div>
          <Paper sx={{ mb: 2, mt: 2 }} elevation={1}>
            <Box sx={{ width: "100%", maxWidth: 500, p: 4 }}>
              <Typography variant="subtitle2" display="block" gutterBottom>
                Total Quantity :{" "}
                <strong style={{ color: "red" }}>
                  {totalPc * quantity || ""} {unit}
                </strong>
              </Typography>
              <Typography variant="overline" display="block" gutterBottom>
                {price &&
                  totalPc &&
                  unit &&
                  `@ ₹${(price / totalPc).toFixed(2)} per ${unit}`}
              </Typography>
              <Typography variant="subtitle1" display="block" gutterBottom>
                Total Amount: <strong> ₹{price * quantity}</strong>
              </Typography>
            </Box>
          </Paper>
          {showErr && (
            <Alert sx={{ mb: 4 }} severity="error">
              Please select different pack quantity.
            </Alert>
          )}
          <Button
            disabled={disabled}
            variant="contained"
            size="large"
            onClick={() => handleAddToCart()}
          >
            Add Product to LIST
          </Button>
        </div>
      </Grid>
    </Grid>
  );
}

export default ProductSelection;
